import { configureStore } from "@reduxjs/toolkit"

import paymentCallbackReducer from "./reducers/payment.callback.reducer"

export default configureStore({
    reducer: {
        payment_callback: paymentCallbackReducer,
    }
})